import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { getApiErrorMessage } from './helpers/apiErrorMessage';

function OtherUserFollowing() {
    const { userId } = useParams();
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [following, setFollowing] = useState([]);
    const [isPrivate, setIsPrivate] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const load = async () => {
            setLoading(true);
            setError(null);
            setIsPrivate(false);
            try {
                const userRes = await axios.get(`/api/users/${userId}`);
                setUser(userRes.data);

                try {
                    const followingRes = await axios.get(`/api/users/${userId}/following`);
                    setFollowing(followingRes.data);
                } catch (err) {
                    if (err.response?.status === 403) {
                        setIsPrivate(true);
                        setFollowing([]);
                    } else {
                        throw err;
                    }
                }
            } catch (err) {
                setError(getApiErrorMessage(err, 'load this user following'));
            } finally {
                setLoading(false);
            }
        };
        load();
    }, [userId]);

    if (loading) {
        return <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center">Loading...</div>;
    }

    if (!user) {
        return <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center">User not found</div>;
    }

    return (
        <div className="min-h-screen bg-gray-900 text-white px-6 pb-10">
            {error && (
                <div className="bg-red-900 border-l-4 border-red-600 p-4 m-4 rounded">
                    <div className="flex justify-between items-center">
                        <p className="text-red-200">{error}</p>
                        <button onClick={() => setError(null)} className="text-red-400 hover:text-red-200 text-2xl">×</button>
                    </div>
                </div>
            )}
            <div className="max-w-3xl mx-auto">
                <button onClick={() => navigate(`/profile/${userId}`)} className="text-gray-400 hover:text-white mb-6 flex items-center gap-2 transition">
                    <i className="fas fa-arrow-left"></i> Back to profile
                </button>
                <h1 className="text-3xl font-bold mb-6">{user.username} is Following</h1>

                {isPrivate ? (
                    <p className="text-gray-400">This user has hidden following.</p>
                ) : following.length === 0 ? (
                    <p className="text-gray-400">Not following anyone yet.</p>
                ) : (
                    <div className="space-y-3">
                        {following.map((followedUser) => (
                            <button
                                key={followedUser.userId}
                                onClick={() => navigate(`/profile/${followedUser.userId}`)}
                                className="w-full bg-gray-800 hover:bg-gray-700 p-4 rounded-lg transition text-left flex justify-between items-center"
                            >
                                <span className="font-semibold text-white">{followedUser.username}</span>
                                <span className="text-gray-400">View profile</span>
                            </button>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

export default OtherUserFollowing;
